<template>
    <div class="sensor">
        <v-layout row align-center class="sensor__label">
            <h2> {{sensor.environment.label}}</h2>
            <v-spacer></v-spacer>
            <v-tooltip left>
                <v-icon slot="activator" class="sensor__connection"
                        :class="{'sensor__connection--active': sensor.hasConnection}">
                    <template v-if="sensor.hasConnection">wifi</template>
                    <template v-else>wifi_off</template>
                </v-icon>
                <span>Letzte Verbindung: {{new Date(sensor.ts).toLocaleString('de-DE')}}</span>
            </v-tooltip>
        </v-layout>

        <v-layout row wrap justify-space-between class="sensor__values" v-if="sensor.values">
            <v-flex shrink class="sensor__values__box">
                <h2>
                    <v-icon large light :class="roomClimateIcon(sensor.values.co2.val)">
                        {{roomClimateIcon(sensor.values.co2.val)}}
                    </v-icon>
                </h2>
                Luftqualität (CO<sub>2</sub> {{sensor.values.co2.val}}, VOC {{sensor.values.voc.val}})
            </v-flex>
            <v-flex shrink class="sensor__values__box">
                <h4>{{correctTemp(sensor.values.temperature.val, sensor.values.temperatureSCD.val)}}</h4>
                Temperatur
            </v-flex>
            <v-flex shrink class="sensor__values__box">
                <h2>{{correctHum(sensor.values.humidity.val, sensor.values.temperature.val,
                    sensor.values.temperatureSCD.val)}}</h2>
                Feuchtigkeit
            </v-flex>
            <v-flex shrink class="sensor__values__box">
                <h2>{{lightText(sensor.values.light.val)}}</h2>
                Licht
            </v-flex>
            <v-flex shrink class="sensor__values__box boxbtn" @click="$router.push({name: 'carecall'})">
                <h2>{{sensor.alarmSeries[12].length}} Pflegerufe</h2>
                letzte 12h
            </v-flex>
        </v-layout>

        <h4 class="sensor__novalues" v-else>Keine Sensorwerte vorhanden. Bitte Konfiguration überprüfen.</h4>

        <footer class="sensor__footer">
            <v-layout row align-center>
                Id: {{sensor.device}}
                <v-spacer></v-spacer>
                <v-btn icon flat color="white" class="ma-0" :to="{name: 'sensor-edit', params:{id: sensor.device}}">
                    <v-icon>settings</v-icon>
                </v-btn>
            </v-layout>
        </footer>
        <div v-if="!sensor.hasConnection" class="sensor__no-connection"></div>
    </div>
</template>

<script>
export default {
  name: 'SensorOverview',
  props: ['sensor', 'edit'],
  methods: {
    correctTemp (tSHT, tSCD) {
      if (tSHT === '?') {
        return tSHT
      }
      let tfSHT = parseFloat(tSHT)
      let tfSCD = parseFloat(tSCD)
      let delta = tfSCD - tfSHT
      if (delta > 1.8) {
        return (tfSHT - 7.9).toFixed(1) + ` (${tfSCD} SCD, ${tfSHT} SHT, Δ ${delta.toFixed(2)})`
      } else {
        return `Kal. (${tfSCD} SCD, ${tfSHT} SHT, Δ ${delta.toFixed(2)})`
      }
    },
    correctHum (h, tSHT, tSCD) {
      let hi = parseFloat(h)
      if (tSHT === '?' || isNaN(hi)) {
        return h
      }

      let tfSHT = parseFloat(tSHT)
      let tfSCD = parseFloat(tSCD)

      let delta = tfSCD - tfSHT
      if (delta > 1.8) {
        let t2 = tfSHT - 7.9
        let lambda = 243.12
        let beta = 17.62
        let rh = Math.round(hi * Math.exp((beta * tfSHT) / (lambda + tfSHT)) / Math.exp((beta * t2) / (lambda + t2)))
        return `${rh}% (U1 ${hi})`
      } else {
        return '?'
      }
    },
    roomClimateIcon (val) {
      if (val === '?') {
        return 'remove_circle_outline'
      }
      val = parseInt(val)
      if (val < 1000) {
        return 'sentiment_satisfied_alt'
      }
      if (val < 2000) {
        return 'sentiment_dissatisfied'
      }
      return 'sentiment_very_dissatisfied'
    },
    lightText (val) {
      if (val === '?') {
        return val
      }
      let light = parseInt(val)
      if (light < 10) {
        return 'Dunkel'
      }
      return 'Hell'
    }
  }
}
</script>

<style lang="scss">
    .sensor {
        position: relative;

        &__values {
            margin: 0 24px;

            &__box {
                white-space: nowrap;
                border-radius: 2px;
                text-align: center;
                display: inline-block;
                padding: 12px;
                margin-bottom: 16px;
                background-color: rgba(149, 119, 211, 0.07);
                min-width: 145px;

                &.boxbtn {
                    cursor: pointer;

                    &:hover {
                        background-color: rgba(111, 80, 211, 0.07);
                    }
                }

                .sentiment_satisfied_alt {
                    color: #7CB342;
                }

                .sentiment_dissatisfied {
                    color: #F57F17;
                }

                .sentiment_very_dissatisfied {
                    color: #D84315;
                }

                h2 {
                    font-family: 'Kameron', serif;
                }
            }
        }

        &__no-connection {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(232, 224, 229, 0.55);
            pointer-events: none;
        }
    }
</style>
